import {graphql} from 'gatsby'
import React from 'react'

import TitleWithAccordion from '@/sections/title-with-accordion'

import type {FaqSliceFragment} from '@/graphql-types'

type Props = {
    slice: FaqSliceFragment
    dataTestId?: string
}

export const FAQSlice = ({slice, dataTestId}: Props) => {
    const items = slice.items.map((faq) => {
        return {
            title: faq.question,
            body: faq.answer.richText,
            image: faq.image,
            icon: faq.icon,
        }
    })

    return (
        <TitleWithAccordion
            title={slice.primary.title}
            items={items}
            collapsible={slice.primary.collapsible}
            dataTestId={dataTestId}
        />
    )
}

export const faqSliceFragment = graphql`
    fragment FAQSlice on PrismicSlicePageDataBodyFaq {
        __typename
        primary {
            title
            collapsible
        }
        items {
            question
            answer {
                richText
            }
            image {
                dimensions {
                    height
                    width
                }
                alt
                copyright
                url
            }
            icon {
                dimensions {
                    height
                    width
                }
                alt
                copyright
                url
            }
        }
    }
`
